import { Link } from '@/lib/nav';
import { ArrowRight } from 'lucide-react';
import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { LinkButton } from '@/components/primitives/Button';
import { ROUTES } from '@/lib/routes';

const REASONS = [
  {
    title: 'Corpus curricular argentino completo',
    body: 'NAP nacional + diseños de las 24 jurisdicciones, con jerarquía preservada.',
  },
  {
    title: 'Cita textual al documento original',
    body: 'Cada respuesta apunta a documento, página y jurisdicción. Trazable.',
  },
  {
    title: 'Política compartida con el integrador',
    body: 'Si SICA devuelve cita, tu agente debe mostrarla. Trazabilidad regulatoria, no nice-to-have.',
  },
];

const USE_CASES = [
  'Tutor IA para estudiantes anclado a su currículum jurisdiccional.',
  'Asistente de planificación docente con cita textual.',
  'Auditoría automática de planificaciones institucionales.',
  'Análisis curricular comparado para investigación.',
];

export function Desarrolladores() {
  return (
    <>
      <section className="rule-bottom">
        <Container className="pt-16 pb-16 md:pt-24 md:pb-20">
          <Eyebrow className="mb-8">Para desarrolladores de IA</Eyebrow>
          <h1 className="max-w-5xl font-display text-5xl font-medium leading-[1.05] tracking-tight text-accent md:text-6xl lg:text-7xl">
            Conectá tu agente
            <br />
            <span className="font-normal italic">al corpus curricular argentino.</span>
          </h1>
          <p className="mt-8 max-w-prose text-lg leading-relaxed text-ink-muted md:text-xl">
            Mismas garantías de fidelidad que SICA. Vía Model Context Protocol.
          </p>
          <div className="mt-10">
            <LinkButton href={ROUTES.producto.mcp} variant="institutional" size="xl">
              Ir a la documentación
              <ArrowRight size={16} />
            </LinkButton>
          </div>
        </Container>
      </section>

      <Section ariaLabelledby="reasons-title" className="bg-paper-tinted/40">
        <Container>
          <h2 id="reasons-title" className="mb-10 max-w-editorial font-serif text-3xl font-normal tracking-tight">
            Un LLM genérico no sabe qué es un NAP. SICA sí.
          </h2>
          <div className="grid gap-4 sm:grid-cols-3">
            {REASONS.map((r) => (
              <div key={r.title} className="rounded-lg border border-line bg-paper p-5">
                <h3 className="text-base font-semibold tracking-tight">{r.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted">{r.body}</p>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      <Section ariaLabelledby="use-cases-title">
        <Container width="editorial">
          <Eyebrow>Casos de uso típicos</Eyebrow>
          <h2 id="use-cases-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Cuatro usos donde SICA cambia la calidad de la salida.
          </h2>
          <ul className="mt-8 flex flex-col">
            {USE_CASES.map((c) => (
              <li
                key={c}
                className="border-t border-line py-5 font-serif text-lg leading-snug text-ink first:border-t-0"
              >
                {c}
              </li>
            ))}
          </ul>
        </Container>
      </Section>

      <Section ariaLabelledby="next-title" className="border-t border-line">
        <Container width="editorial">
          <Eyebrow>Próximo paso</Eyebrow>
          <h2 id="next-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Documentación técnica: tools, transports, política de fuentes.
          </h2>
          <div className="mt-8 flex flex-wrap gap-3">
            <LinkButton href={ROUTES.producto.mcp} variant="primary">
              Ver documentación MCP
              <ArrowRight size={14} />
            </LinkButton>
            <Link
              to={`${ROUTES.contacto}?perfil=desarrollador`}
              className="focus-ring inline-flex items-center gap-1.5 rounded-full border border-line_strong px-5 py-2.5 text-sm font-medium text-ink hover:border-ink hover:bg-ink hover:text-paper"
            >
              Hablar con el equipo técnico
            </Link>
          </div>
        </Container>
      </Section>
    </>
  );
}
